module.exports = __webpack_public_path__ + "static/media/logo-ba.8ee55e76.svg";